module.exports = __webpack_public_path__ + "static/media/ios.af5f7a30.png";